import {
	FORMULA_OPERATIONS as FP,
	GeometryTypes,
	IReferenceDimension,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * Round rect preset definition
 * ECMA-376, Third Edition, Part 1 - Fundamentals And Markup Language Reference
 * /OfficeOpenXML-DrawingMLGeometries/presetShapeDefinitions.xml
 */
export const roundRect: IPresetGeometry = {

	ahLst: [
		{ gdRefX: "adj", maxX: 50000, minX: 0, pos: { x: "x1", y: "t" },
			referenceDimension: IReferenceDimension.SS },
	],

	avList: [
		{ name: "adj", fmla: { operation: FP.LiteralValue, operands: [16667] } },
	],

	gdLst: [
		{ name: "a", fmla: { operation: FP.PinTo, operands: [0, "adj", 50000] } },
		{ name: "x1", fmla: { operation: FP.MultiplyDivide, operands: ["ss", "a", 100000] } },
		{ name: "x2", fmla: { operation: FP.AddSubtract, operands: ["r", 0, "x1"] } },
		{ name: "y2", fmla: { operation: FP.AddSubtract, operands: ["b", 0, "x1"] } },
		{ name: "il", fmla: { operation: FP.MultiplyDivide, operands: ["x1", 29289, 100000] } },
		{ name: "ir", fmla: { operation: FP.AddSubtract, operands: ["r", 0, "il"] } },
		{ name: "ib", fmla: { operation: FP.AddSubtract, operands: ["b", 0, "il"] } },
	],

	pathLst: [{
		operations: [
			{ pt: { x: "l", y: "x1" }, type: PathOperationTypes.MOVE_TO },
			{ wR: "x1", hR: "x1", stAng: "cd2", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ pt: { x: "x2", y: "t" }, type: PathOperationTypes.LINE_TO },
			{ wR: "x1", hR: "x1", stAng: "3cd4", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ pt: { x: "r", y: "y2" }, type: PathOperationTypes.LINE_TO },
			{ wR: "x1", hR: "x1", stAng: "0", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ pt: { x: "x1", y: "b" }, type: PathOperationTypes.LINE_TO },
			{ wR: "x1", hR: "x1", stAng: "cd4", swAng: "cd4", type: PathOperationTypes.ARC_TO },
			{ type: PathOperationTypes.CLOSE },
		],
	}],
	presetShape: ShapeType.roundRect,
	rect: { l: "il", t: "il", r: "ir", b: "ib" },
	type: GeometryTypes.PRESET,
};

/**
 * <roundRect>
 *  <avLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *  <gd name="adj" fmla="val 16667" />
 * </avLst>
 * <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *  <gd name="a" fmla="pin 0 adj 50000" />
 *  <gd name="x1" fmla="* / ss a 100000" />
 *  <gd name="x2" fmla="+- r 0 x1" />
 *  <gd name="y2" fmla="+- b 0 x1" />
 *  <gd name="il" fmla="* / x1 29289 100000" />
 *  <gd name="ir" fmla="+- r 0 il" />
 *  <gd name="ib" fmla="+- b 0 il" />
 * </gdLst>
 * <ahLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *  <ahXY gdRefX="adj" minX="0" maxX="50000">
 *    <pos x="x1" y="t" />
 *  </ahXY>
 * </ahLst>
 * <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *  <cxn ang="3cd4">
 *    <pos x="hc" y="t" />
 *  </cxn>
 *  <cxn ang="cd2">
 *    <pos x="l" y="vc" />
 *  </cxn>
 *  <cxn ang="cd4">
 *    <pos x="hc" y="b" />
 *  </cxn>
 *  <cxn ang="0">
 *    <pos x="r" y="vc" />
 *  </cxn>
 * </cxnLst>
 * <rect l="il" t="il" r="ir" b="ib" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main" />
 * <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *  <path>
 *    <moveTo>
 *      <pt x="l" y="x1" />
 *    </moveTo>
 *    <arcTo wR="x1" hR="x1" stAng="cd2" swAng="cd4" />
 *    <lnTo>
 *      <pt x="x2" y="t" />
 *    </lnTo>
 *    <arcTo wR="x1" hR="x1" stAng="3cd4" swAng="cd4" />
 *    <lnTo>
 *      <pt x="r" y="y2" />
 *    </lnTo>
 *    <arcTo wR="x1" hR="x1" stAng="0" swAng="cd4" />
 *    <lnTo>
 *      <pt x="x1" y="b" />
 *    </lnTo>
 *    <arcTo wR="x1" hR="x1" stAng="cd4" swAng="cd4" />
 *    <close />
 *  * </path>
 * </pathLst>
 * </roundRect>
 */
